import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';
import { finalize, map, tap } from 'rxjs/operators';
import { IsDeviceOnlineService } from 'src/app/services/is-online/is-online.service';
import { SyncPwaDataService } from 'src/app/services/sync-pwa-data/sync-pwa-data.service';
import { environment } from 'src/environments/environment';

type DuplicateVinEntry = {
  vehicleId: string;
  vinNumber: string;
  plateNumber: string;
  lastUpdatedAt: string;
};

function convertDateTimeFormat(dateTimeString: string) {
  try {
    const date = new Date(dateTimeString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    const formattedDateTime = `${day}/${month}/${year} ${String(hours).padStart(
      2,
      '0'
    )}:${minutes}:${seconds} ${ampm}`;

    return formattedDateTime;
  } catch (error) {
    console.error('Error parsing or formatting date:', error);
    return 'Invalid Date'; // Or handle the error as appropriate for your application
  }
}
@Component({
  selector: 'app-offline-data',
  templateUrl: './offline-data.component.html',
  styleUrls: ['./offline-data.component.scss']
})
export class OfflineDataComponent implements OnInit {
  dummySyncCompleteFlag = true;
  modalRef?: BsModalRef;
  @ViewChild('template') modalTemplate!: TemplateRef<void>;

  duplicateVinEntryModalRef?: BsModalRef;
  currentlySelectedVin: string | undefined = undefined;

  vinOfEntryToBeDeleted: string | undefined = undefined;

  duplicateVinEntryCount = new BehaviorSubject(-1);
  duplicateVinEntryLoading = new BehaviorSubject(false);
  duplicateVinEntryArray = new BehaviorSubject<DuplicateVinEntry[]>([]);

  constructor(
    readonly _syncPwaDataService: SyncPwaDataService,
    readonly _isDeviceOnlineService: IsDeviceOnlineService,
    private readonly _router: Router,
    private modalService: BsModalService,
    private readonly _httpClient: HttpClient
  ) {}

  data$ = this._syncPwaDataService.state$;
  isCurrentlyPushing$ = this._syncPwaDataService.isCurrentlyPushing$;

  ngOnInit(): void {
    console.log('inside ngOnInit');
    this._syncPwaDataService.reducer({ type: 'GET_INITIAL_STATE' });
  }

  showStateForDev() {
    this._syncPwaDataService.showCurrentStateNow();
  }

  setThisVinAsCurrentVin(vin: string) {
    console.log('setThisVinAsCurrentVin');
    localStorage.setItem('current-local-vin-id-for-pwa', vin);
    // this.openModal(this.modalTemplate);
    // alert('Please go to the Information tab to continue editing.');
    // this._router.navigate(['/vam/offne-data']);
    this._router.navigate(['/vam/information']);
  }

  async syncOfflineDataForVin(vin: string) {
    // this.duplicateVinEntryModalRef.hide();
    await this._syncPwaDataService.syncData(vin);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  goToInformationTab() {
    this._router.navigate(['/vam/information']);
  }

  deleteEntryForThisVin() {
    this._syncPwaDataService.deleteEntryForThisVin(this.vinOfEntryToBeDeleted);
    this.modalRef?.hide();
  }

  openModalForDeleteEntry(template: TemplateRef<void>, vin: string) {
    this.vinOfEntryToBeDeleted = vin;
    this.modalRef = this.modalService.show(template);
  }

  openModalForDuplicateVinEntry(template: TemplateRef<void>, vin: string) {
    this.duplicateVinEntryLoading.next(true);
    this.currentlySelectedVin = vin;
    this.duplicateVinEntryModalRef = this.modalService.show(template);

    this._httpClient
      .post(`${environment.api}/car/get/duplicate-vin`, { vin_number: vin })
      .pipe(
        tap((response) => {
          console.log('inside tap', response);
          let duplicateEntryCount = response?.['data']?.['vehicle_count'] ?? 0;
          this.duplicateVinEntryCount.next(duplicateEntryCount);
        }),
        tap((response) => {
          const vehicleDataArray = response?.['data']?.['vehicle'];
          if (Array.isArray(vehicleDataArray)) {
            const _duplicateVinEntryArray: DuplicateVinEntry[] = [];

            for (let i = 0; i < vehicleDataArray.length; i++) {
              const objectToPush: DuplicateVinEntry = {
                vehicleId: vehicleDataArray[i]?.['vehicle_id'],
                vinNumber: vehicleDataArray[i]?.['vin_number'],
                plateNumber: vehicleDataArray[i]?.['plate_number'],
                lastUpdatedAt: convertDateTimeFormat(vehicleDataArray[i]?.['updated_at'])
              };
              _duplicateVinEntryArray.push(objectToPush);
            }
            this.duplicateVinEntryArray.next(_duplicateVinEntryArray);
          }
        }),
        finalize(() => this.duplicateVinEntryLoading.next(false))
      )
      .subscribe({
        next: (res) => {
          // nothing to do here
        }
      });
  }

  unlockThisVin(vin: string) {
    console.log('clicked on unlockThisVin', vin);
    this._syncPwaDataService.unlockThisVin(vin);
  }

  lockThisVin(vin: string) {
    console.log('clicked on lockThisVin', vin);
    this._syncPwaDataService.lockThisVin(vin);
  }

  async updateEntryWithExistingVehicleId(vin: string, vehicleId: string) {
    console.log('inside updateEntryWithExistingVehicleId');
    console.log({ vin, vehicleId });
    await this._syncPwaDataService.updateEntryWithExistingVehicleId(vin, vehicleId);
    await this.syncOfflineDataForVin(vin);
  }
}
